<template>
  <div class="section-new-order section-full">
    <form-staff :title="$gettext('Add Staff')"/>
  </div>
</template>

<script>
import FormStaff from '@/components/FormStaff.vue';

export default {
  name: 'AddStaff',
  components: {
    FormStaff,
  },
};
</script>
